import { render, staticRenderFns } from "./VpayChargeApplyBonus.vue?vue&type=template&id=a03c9c70&scoped=true"
import script from "./VpayChargeApplyBonus.vue?vue&type=script&lang=js"
export * from "./VpayChargeApplyBonus.vue?vue&type=script&lang=js"
import style0 from "./VpayChargeApplyBonus.vue?vue&type=style&index=0&id=a03c9c70&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03c9c70",
  null
  
)

export default component.exports